import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import Table from '../Table';

import './exception-content.scss';

const ExceptionContent = () => {
	const { t } = useTranslation();
	const { id } = useParams();
	const pageHeading = {
		exceptions: {
			heading: t('exceptions'),
			description: t('exceptions_desc')
		},
		'api-errors': {
			heading: t('api_errors'),
			description: t('api_errors_desc')
		}
	}
	const Errorcolumns = [
		{
			heading: `${t('code')}`,
			accessor: 'code',
		},
		{
			heading: `${t('type')}`,
			accessor: 'type'
		},
		{
			heading: `${t('key')}`,
			accessor: 'errors'
		},
		{
			heading: `${t('message')}`,
			accessor: 'message'
		},
	];

	const data = [
		{
			code: 40001,
			errors: 'email_error',
			type: 'error',
			message: t('email_error')
		},
		{
			code: 40002,
			errors: 'invalid_or_expired_token',
			type: 'error',
			message: t('invalid_or_expired_token')
		},
		{
			code: 40003,
			errors: 'forget_password_link_expired',
			type: 'error',
			message: t('forget_password_link_expired')
		},
		{
			code: 40004,
			errors: 'something_wrong',
			type: 'error',
			message: t('something_wrong')
		},
		{
			code: 40005,
			errors: 'no_instructor_found',
			type: 'error',
			message: t('no_instructor_found')
		},
		{
			code: 40006,
			errors: 'invite_template_not_found',
			type: 'error',
			message: t('invite_template_not_found')
		},
		{
			code: 40007,
			errors: 'candidate_not_exists',
			type: 'error',
			message: t('candidate_not_exists')
		},
		{
			code: 40008,
			errors: 'assessment_expired',
			type: 'error',
			message: t('assessment_expired')
		},
		{
			code: 40009,
			errors: 'candidates_already_invited',
			type: 'error',
			message: t('candidates_already_invited')
		},
		{
			code: 40010,
			errors: 'file_not_attached',
			type: 'error',
			message: t('file_not_attached')
		},
		{
			code: 40011,
			errors: 'method_not_allowed',
			type: 'error',
			message: t('method_not_allowed')
		},
		{
			code: 40012,
			errors: 'already_registered',
			type: 'error',
			message: t('already_registered')
		},
		{
			code: 40013,
			errors: 'candidate_assessment_not_found',
			type: 'error',
			message: t('candidate_assessment_not_found')
		},
		{
			code: 40014,
			errors: 'candidate_already_exists',
			type: 'error',
			message: t('candidate_already_exists')
		},
		{
			code: 40015,
			errors: 'candidate_assessment_status_not_found',
			type: 'error',
			message: t('candidate_assessment_status_not_found')
		},
		{
			code: 40016,
			errors: 'something_went_wrong',
			type: 'error',
			message: t('something_went_wrong')
		},
		{
			code: 40017,
			errors: 'token_not_decoded',
			type: 'error',
			message: t('token_not_decoded')
		},
		{
			code: 40018,
			errors: 'candidate_not_exists',
			type: 'error',
			message: t('candidate_not_exists')
		},
		{
			code: 40019,
			errors: 'invalid_school',
			type: 'error',
			message: t('invalid_school')
		},
		{
			code: 40020,
			errors: 'assessment_not_exists',
			type: 'error',
			message: t('assessment_not_exists')
		},
		{
			code: 40021,
			errors: 'assessment_status_not_found',
			type: 'error',
			message: t('assessment_status_not_found')
		},
		{
			code: 40022,
			errors: 'assessment_not_found_in_time_period',
			type: 'error',
			message: t('assessment_not_found_in_time_period')
		},
		{
			code: 40023,
			errors: 'image_not_provided',
			type: 'error',
			message: t('image_not_provided')
		},
		{
			code: 40024,
			errors: 'report_delivery_not_found',
			type: 'error',
			message: t('report_delivery_not_found')
		},
		{
			code: 40025,
			errors: 'id_required_for_updating',
			type: 'error',
			message: t('id_required_for_updating')
		},
		{
			code: 40026,
			errors: 'id_required_for_deleting',
			type: 'error',
			message: t('id_required_for_deleting')
		},
		{
			code: 40027,
			errors: 'otp_expired',
			type: 'error',
			message: t('otp_expired')
		},
		{
			code: 40028,
			errors: 'user_not_found',
			type: 'error',
			message: t('user_not_found')
		},
		{
			code: 40029,
			errors: 'invalid_otp_or_email',
			type: 'error',
			message: t('invalid_otp_or_email')
		},
		{
			code: 40030,
			errors: 'candidate_assessment_not_found',
			type: 'error',
			message: t('candidate_assessment_not_found')
		},
		// New entries from CSV
		{
			code: 40031,
			errors: 'serialization_error',
			type: 'error',
			message: t('serialization_error')
		},
		{
			code: 40032,
			errors: 'playlist_not_found_of_school',
			type: 'error',
			message: t('playlist_not_found_of_school')
		},
		{
			code: 40033,
			errors: 'assessment_not_found_of_school',
			type: 'error',
			message: t('assessment_not_found_of_school')
		},
		{
			code: 40034,
			errors: 'invalid_data',
			type: 'error',
			message: t('invalid_data')
		},
		{
			code: 40035,
			errors: 'template_not_duplicated',
			type: 'error',
			message: t('template_not_duplicated')
		},
		{
			code: 40036,
			errors: 'status_not_found',
			type: 'error',
			message: t('status_not_found')
		},
		{
			code: 40037,
			errors: 'id_not_found',
			type: 'error',
			message: t('id_not_found')
		},
		{
			code: 40038,
			errors: 'assessment_not_found',
			type: 'error',
			message: t('assessment_not_found')
		},
		{
			code: 40039,
			errors: 'data_updated_successfully',
			type: 'error',
			message: t('data_updated_successfully')
		},
		{
			code: 40040,
			errors: 'assessment_not_exists',
			type: 'error',
			message: t('assessment_not_exists')
		},
		{
			code: 40041,
			errors: 'section_not_exist',
			type: 'error',
			message: t('section_not_exist')
		},
		{
			code: 40042,
			errors: 'candidate_assessment_section_invite_not_found',
			type: 'error',
			message: t('candidate_assessment_section_invite_not_found')
		},
		{
			code: 40043,
			errors: 'candidate_invite_assessment_section_not_found',
			type: 'error',
			message: t('candidate_invite_assessment_section_not_found')
		},
		{
			code: 40044,
			errors: 'assessment_date_changed',
			type: 'error',
			message: t('assessment_date_changed')
		},
		{
			code: 40045,
			errors: 'email_sent_to_all_candidates',
			type: 'error',
			message: t('email_sent_to_all_candidates')
		},
		{
			code: 40046,
			errors: 'assessment_expire_time_greater_than_start',
			type: 'error',
			message: t('assessment_expire_time_greater_than_start')
		},
		{
			code: 40047,
			errors: 'end_at_is_required',
			type: 'error',
			message: t('end_at_is_required')
		},
		{
			code: 40048,
			errors: 'email_and_password_is_required',
			type: 'error',
			message: t('email_and_password_is_required')
		},
		{
			code: 40049,
			errors: 'invalid_credentials',
			type: 'error',
			message: t('invalid_credentials')
		},
		{
			code: 40050,
			errors: 'invalid_token',
			type: 'error',
			message: t('invalid_token')
		},
		{
			code: 40051,
			errors: 'candidate_invite_assessment_section_not_found',
			type: 'error',
			message: t('candidate_invite_assessment_section_not_found')
		},
		{
			code: 40052,
			errors: 'verification_failed',
			type: 'error',
			message: t('verification_failed')
		},
		{
			code: 40053,
			errors: 'exam_date_over',
			type: 'error',
			message: t('exam_date_over')
		},
		{
			code: 40054,
			errors: 'token_required',
			type: 'error',
			message: t('token_required')
		},
		{
			code: 40055,
			errors: 'verify_audience',
			type: 'error',
			message: t('verify_audience')
		},
		{
			code: 40056,
			errors: 'registration_failed',
			type: 'error',
			message: t('registration_failed')
		},
		{
			code: 40057,
			errors: 'assessment_taken',
			type: 'error',
			message: t('assessment_taken')
		},
		{
			code: 40058,
			errors: 'invalid_page',
			type: 'error',
			message: t('invalid_page')
		},
		{
			code: 40059,
			errors: 'range_parameter_required',
			type: 'error',
			message: t('range_parameter_required')
		},
		{
			code: 40060,
			errors: 'invalid_instructor',
			type: 'error',
			message: t('invalid_instructor')
		},
		{
			code: 40061,
			errors: 'session_report_not_exist',
			type: 'error',
			message: t('session_report_not_exist')
		},
		{
			code: 40062,
			errors: 'file_upload_failed',
			type: 'error',
			message: t('file_upload_failed')
		},
		{
			code: 40063,
			errors: 'notification_not_created',
			type: 'error',
			message: t('notification_not_created')
		},
		{
			code: 40064,
			errors: 'assessment_status_draft',
			type: 'error',
			message: t('assessment_status_draft')
		},
		{
			code: 40065,
			errors: 'section_not_exist',
			type: 'error',
			message: t('section_not_exist')
		},
		{
			code: 40066,
			errors: 'invite_not_found',
			type: 'error',
			message: t('invite_not_found')
		},
		{
			code: 40067,
			errors: 'template_not_found',
			type: 'error',
			message: t('template_not_found')
		},
		{
			code: 40068,
			errors: 'section_not_found',
			type: 'error',
			message: t('section_not_found')
		},
		{
			code: 40069,
			errors: 'section_or_candidate_not_exist',
			type: 'error',
			message: t('section_or_candidate_not_exist')
		},
		{
			code: 40070,
			errors: 'no_record_found',
			type: 'error',
			message: t('no_record_found')
		},
		{
			code: 40071,
			errors: 'reminder_sent',
			type: 'error',
			message: t('reminder_sent')
		},
		{
			code: 40072,
			errors: 'invalid_json',
			type: 'error',
			message: t('invalid_json')
		},
		{
			code: 40073,
			errors: 'token_not_decoded',
			type: 'error',
			message: t('token_not_decoded')
		},
		{
			code: 40074,
			errors: 'token_has_no_user_id',
			type: 'error',
			message: t('token_has_no_user_id')
		},
		{
			code: 40075,
			errors: 'no_activities_provided',
			type: 'error',
			message: t('no_activities_provided')
		},
		{
			code: 40076,
			errors: 'failed_to_fetch_activity_data',
			type: 'error',
			message: t('failed_to_fetch_activity_data')
		},
		{
			code: 40077,
			errors: 'failed_to_duplicate_activities',
			type: 'error',
			message: t('failed_to_duplicate_activities')
		},
		{
			code: 40078,
			errors: 'no_items_provided',
			type: 'error',
			message: t('no_items_provided')
		},
		{
			code: 40079,
			errors: 'failed_to_fetch_item_data',
			type: 'error',
			message: t('failed_to_fetch_item_data')
		},
		{
			code: 40080,
			errors: 'invalid_response',
			type: 'error',
			message: t('invalid_response')
		},
		{
			code: 40081,
			errors: 'question_not_created',
			type: 'error',
			message: t('question_not_created')
		},
		{
			code: 40082,
			errors: 'superuser_cannot_create_entity',
			type: 'error',
			message: t('superuser_cannot_create_entity')
		},
		{
			code: 40083,
			errors: 'assigned_higher_role',
			type: 'error',
			message: t('assigned_higher_role')
		},
		{
			code: 40084,
			errors: 'alert_not_found',
			type: 'error',
			message: t('alert_not_found')
		},
		{
			code: 40085,
			errors: 'instructor_required',
			type: 'error',
			message: t('instructor_required')
		},
		{
			code: 40086,
			errors: 'invalid_candidate',
			type: 'error',
			message: t('invalid_candidate')
		},
		{
			code: 40087,
			errors: 'candidate_invite_assessment_section_not_unique',
			type: 'error',
			message: t('candidate_invite_assessment_section_not_unique')
		},
		{
			code: 40088,
			errors: 'candidate_invite_assessment_section_id_not_given',
			type: 'error',
			message: t('candidate_invite_assessment_section_id_not_given')
		},
		{
			code: 40089,
			errors: 'event_not_found',
			type: 'error',
			message: t('event_not_found')
		},
		{
			code: 40090,
			errors: 'ai_event_not_found',
			type: 'error',
			message: t('ai_event_not_found')
		},
		{
			code: 40091,
			errors: 'invalid_section_session',
			type: 'error',
			message: t('invalid_section_session')
		},
		{
			code: 40092,
			errors: 'playlist_id_not_given',
			type: 'error',
			message: t('playlist_id_not_given')
		},
		{
			code: 40093,
			errors: 'sessions_not_found',
			type: 'error',
			message: t('sessions_not_found')
		},
		{
			code: 40094,
			errors: 'panel_id_not_given',
			type: 'error',
			message: t('panel_id_not_given')
		},
		{
			code: 40095,
			errors: 'section_session_with_evaluation_already_exist',
			type: 'error',
			message: t('section_session_with_evaluation_already_exist')
		},
		{
			code: 40096,
			errors: 'evaluation_id_not_given',
			type: 'error',
			message: t('evaluation_id_not_given')
		},
		{
			code: 40097,
			errors: 'room_already_exist',
			type: 'error',
			message: t('room_already_exist')
		},
		{
			code: 40098,
			errors: 'recording_not_found',
			type: 'error',
			message: t('recording_not_found')
		},
		{
			code: 40099,
			errors: 'room_not_exist',
			type: 'error',
			message: t('room_not_exist')
		},
		{
			code: 40100,
			errors: 'recording_not_started',
			type: 'error',
			message: t('recording_not_started')
		},
		{
			code: 40101,
			errors: 'recording_not_stopped',
			type: 'error',
			message: t('recording_not_stopped')
		},
		{
			code: 40102,
			errors: 'recording_not_exist',
			type: 'error',
			message: t('recording_not_exist')
		},
		{
			code: 40103,
			errors: 'source_id_not_provided',
			type: 'error',
			message: t('source_id_not_provided')
		},
		{
			code: 50012,
			errors: 'session_id_or_auto_record_required',
			type: 'error',
			message: t('session_id_or_auto_record_required')
		},
		{
			code: 50001,
			errors: 'password_reset_token_sent',
			type: 'success',
			message: t('password_reset_token_sent')
		},
		{
			code: 50002,
			errors: 'password_reset_successful',
			type: 'success',
			message: t('password_reset_successful')
		},
		{
			code: 50003,
			errors: 'enter_new_password',
			type: 'success',
			message: t('enter_new_password')
		},
		{
			code: 50004,
			errors: 'password_updated_successfully',
			type: 'success',
			message: t('password_updated_successfully')
		},
		{
			code: 50005,
			errors: 'otp_sent',
			type: 'success',
			message: t('otp_sent')
		},
		{
			code: 50006,
			errors: 'data_saved_email_sent',
			type: 'success',
			message: t('data_saved_email_sent')
		},
		{
			code: 50007,
			errors: 'report_delivery_deleted',
			type: 'success',
			message: t('report_delivery_deleted')
		},
		{
			code: 50008,
			errors: 'data_success',
			type: 'success',
			message: t('data_success')
		},
		{
			code: 50009,
			errors: 'bulk_update_successful',
			type: 'success',
			message: t('bulk_update_successful')
		},
		{
			code: 50010,
			errors: 'reminder_sent',
			type: 'success',
			message: t('reminder_sent')
		},
		{
			code: 50011,
			errors: 'reminder_not_sent',
			type: 'success',
			message: t('reminder_not_sent')
		}
	]

	return (
		<div className='compability-content-container'>
			<h1>{pageHeading[id]?.heading}</h1>
			<p>
				{pageHeading[id]?.description}
			</p>
			<h2>{t('errors')}</h2>
			<div>
				<Table
					column={Errorcolumns}
					data={data.filter(item => item.type === 'error')}
					showPagination={false}
					onSortedList={() => null}
				/>
			</div>

			<h2 style={{ marginTop: '15px' }}>{t('success')}</h2>
			<div>
				<Table
					column={Errorcolumns}
					data={data.filter(item => item.type === 'success')}
					showPagination={false}
					onSortedList={() => null}
				/>
			</div>
		</div>
	)
}

export default ExceptionContent